import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DatasourcesDisplayGridRowDataFragmentGql } from './DatasourcesDisplayGridRowDataFragmentGql';

export const DownstreamDatasourcesFilteredByFieldQueryGql: DocumentNode = gql`
query DownstreamDatasourcesFilteredByFieldQuery(
  $selectedFieldId: ID!,
  $first: Int!,
  $offset: Int!,
  $orderBy: PublishedDatasourceSortOrder!
) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      downstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...DatasourcesDisplayGridRowDataFragment
        }
      }
    }
  }
}
${DatasourcesDisplayGridRowDataFragmentGql}
`;
